export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["मिन"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["खरीदें"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["के लिए"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सक्रिय"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["विज्ञापन लिंक"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["मेकर आईडी"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["विवरण"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["टाइमआउट"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["निर्माण तिथि"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["मैं भुगतान करूंगा"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["मैं प्राप्त करूंगा"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ट्रेड सीमा"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सभी"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ट्रेड्स"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["ऑफ़र आईडी"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["रेट"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["खाता चुनें"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सीमा से बाहर"])}
}